import React, { useState, useEffect, useRef, useMemo } from "react";
import { Row, Col, FormGroup, Label, Input, Spinner } from "reactstrap";
import "./resume.css";
import DetailBloc from '../Blocs/DetailBloc';
import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'
import apiResponse from "../../../../../services/apiResponse";


const defaultResume = {
  title: "Analis Anggaran Ahli Madya – Biro Perencanaan Program dan Anggaran",
  dataJabatan: {
    namaJabatan: "Analis Anggaran Ahli Madya",
    kodeJabatan: "-",
    ikhtisar:
      "Melaksanakan kegiatan analisis di bidang penganggaran dalam pengelolaan APBN di lingkup Kementerian Investasi/Badan Koordinasi Penanaman Modal (BKPM).",
    syarat: {
      tingkatPendidikan: "Minimal Diploma IV",
      pendidikan:
        "S-2 ILMU EKONOMI, S-1 ILMU EKONOMI, S-1 ILMU STATISTIK, S-2 HUKUM, S-2 EKONOMI, S-1 EKONOMI, S-2 ILMU ADMINISTRASI, D-IV/S-1 TEKNOLOGI INFORMASI, S-1 ADMINISTRASI, S-1 ILMU MANAJEMEN, D-IV/S-1 EKONOMI, D-IV/S-1 ILMU KOMPUTER, S-1 ILMU KOMUNIKASI, S-1 ILMU HUKUM, S-1 ILMU ADMINISTRASI, S-1 ILMU KOMPUTER, S-2 ILMU MANAJEMEN, S-2 MANAJEMEN, D-IV/S-1 MANAJEMEN.",
      // diklat: "Diklat teknis di bidang penganggaran atau diklat lain yang relevan.",
      // pengalaman:
      //   "Memiliki pengalaman kerja di bidang penyusunan anggaran atau pengelolaan APBN."
    }
  },
  // tugasPokok: [
  //   "Melaksanakan analisis anggaran dan penyusunan rekomendasi program/kegiatan berdasarkan kebijakan dan prioritas nasional.",
  //   "Melakukan penelaahan usulan program dan kegiatan dari unit kerja terkait, termasuk aspek pagu, output, dan outcome.",
  //   "Menyusun bahan pemantauan dan evaluasi pelaksanaan anggaran serta menyiapkan laporan periodik.",
  //   "Memberikan masukan teknis kepada pimpinan terkait penyempurnaan kebijakan dan mekanisme penganggaran."
  // ]
};



const ResumeComponent = ({ 
  work_unit,
  periode,
  position_uuid,
  resume = defaultResume }) => {
  const { title, dataJabatan, tugasPokok } = resume;

  
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState({});
  let resumeBloc = useMemo(() => new DetailBloc(), []);
  const sourceRef = useRef(null);

  const LoadingState = () => (
      <div style={{ 
        padding: "80px 0", 
        display: "flex", 
        flexDirection: "column", 
        alignItems: "center", 
        justifyContent: "center", 
        textAlign: "center" 
      }}>
        <Spinner color="primary" style={{ width: "4rem", height: "4rem" }} />
        <h5 className="mt-4 text-muted">Mengambil data...</h5>
      </div>
    );

  const EmptyState = () => (
      <div style={{ 
        padding: "80px 0", 
        textAlign: "center", 
        display: "flex", 
        flexDirection: "column", 
        alignItems: "center", 
        justifyContent: "center", 
        color: "#6c757d" 
      }}>
        <h5 className="mt-4">Tidak ada data</h5>
        <p className="text-muted">Silakan pilih unit kerja terlebih dahulu</p>
      </div>
  );


  const setTokenAPI = async (currentUuid, periode, token) => {
    if (!currentUuid || !periode) return; 
    const query = {
      work_unit_uuid: currentUuid,
      periode_uuid: periode,
      position_uuid : position_uuid || ''
    }

    await resumeBloc.fetchInfoResume(query, token)
  }

  const reloadResume = async () => {
    if (!work_unit || !periode) return;

    if (sourceRef.current) {
      sourceRef.current.cancel();
    }

    setLoading(true);
    setDetail({});

    const source = cancelToken();
    sourceRef.current = source;

    setTokenAPI(work_unit, periode, source.token);
  };
    
  useEffect(() => {

    const workUnitChanged = work_unit;
    const periodeChanged = periode;
    const positionChanged = position_uuid;

    if (!workUnitChanged || !periodeChanged) {
      setDetail({});
      setLoading(false);
      return;
    }

    setDetail({});
    setLoading(true);

    if (sourceRef.current) {
      sourceRef.current.cancel();
    }

    const source = cancelToken();
    sourceRef.current = source;

    setTokenAPI(work_unit, periode, source.token);

    const subscription = resumeBloc.infoResumeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          setLoading(true);
          break;

        case apiResponse.COMPLETED:
          if (result.data.status) {
            setDetail(result.data.response || {});
          } else {
            setDetail({});
          }
          setLoading(false);
          break;

        case apiResponse.ERROR:
          setDetail({});
          setLoading(false);
          break;

        default:
          break;
      }
    });

    return () => {
      if (sourceRef.current) {
        sourceRef.current.cancel();
      }
      subscription.unsubscribe();
    };

  }, [work_unit, periode, position_uuid]);
      


  if (loading) {
    return <LoadingState />;
  }

  if (!loading && (!detail || Object.keys(detail).length === 0)) {
    return <EmptyState />;
  }


  return (
    <div className="p-3">
      <div className="text-end mb-3">
        <button 
        className="btn btn-primary" 
        onClick={() => { reloadResume(); }}
          >
            Muat ulang resume
          </button>
      </div>

      <table className="table table-bordered resume-table mb-0">
        <tbody>
          {/* HEADER JABATAN */}
          <tr>
            <td colSpan={2} className="text-center fw-semibold">
              {detail.nama_jabatan_full || title}
            </td>
          </tr>

          {/* I. DATA JABATAN */}
          <tr>
            <th colSpan={2} className="section-title">
              I. DATA JABATAN
            </th>
          </tr>

          <tr>
            <th style={{ width: "22%" }}>Nama Jabatan</th>
            <td>{detail.nama_jabatan || "-"}</td>
          </tr>

          <tr>
            <th>Kode Jabatan</th>
            <td>{detail.kode_jabatan || "-"}</td>
          </tr>

          <tr>
            <th>Ikhtisar Jabatan</th>
            <td>{detail.iktisar || "-"}</td>
          </tr>

          {/* Syarat Jabatan dengan sub-baris a–d */}
          <tr>
            <th rowSpan={4} style={{ verticalAlign: "top" }}>
              Syarat Jabatan
            </th>
            <td>
              <b>a. Tingkat Pendidikan</b>
              <br />
              {detail.tingkat_pendidikan || "-"}
            </td>
          </tr>

          <tr>
            <td>
              <b>b. Pendidikan</b>
              <br />
              {detail.pendidikan || "-"}
            </td>
          </tr>

          <tr>
            <td>
              <b>c. Diklat</b>
              <br />
              {detail.diklat || "-"}
            </td>
          </tr>

          <tr>
            <td>
              <b>d. Pengalaman</b>
              <br />
              {detail.pengalaman || "-"}
            </td>
          </tr>

          {/* II. TUGAS POKOK */}
          <tr>
            <th colSpan={2} className="section-title">
              II. TUGAS POKOK
            </th>
          </tr>

          <tr>
            <td colSpan={2}>
               {detail.tugas_pokok ? (
                <ol className="mb-0 ps-3">
                  {(
                    Array.isArray(detail.tugas_pokok)
                      ? detail.tugas_pokok
                      : detail.tugas_pokok.split("\n")
                  ).map((item, idx) => (
                    <li key={idx} className="mb-1">
                      {item}
                    </li>
                  ))}
                </ol>
              ) : null}
            </td>
          </tr>

          {/* Tambah section lain (III, IV, dst.) di bawah sini kalau perlu */}
        </tbody>
      </table>
    </div>
  );
};

export default ResumeComponent;